<template>
	<vs-prompt
		@cancel="date = ''; about = ''"
		@accept="moveTrash"
		:active.sync="popupActive"
		:title="$t('titleDialogMoveTrash')"
		:acceptText="$t('save')"
		:cancelText="$t('cancel')"
		class="add-order-task"
	>
		<div>
			<vx-input-group class="mb-4">
                <div class="form-group form-check">
                    <div class="mb-4"><input class="mr-2" id="reason_7" type="radio" v-model="reason" value="7"> <label for="reason_7">{{ $t('orderFailedFeeNotPaid') }}</label></div>
                    <div class="mb-4"><input class="mr-2" id="reason_8" type="radio" v-model="reason" value="8"> <label for="reason_8">{{ $t('orderFailedFeePartiallyFullyPaid') }}</label></div>
                    <div class="mb-4"><input class="mr-2" id="reason_4" type="radio" v-model="reason" value="4"> <label for="reason_4">{{ $t('clientNotContacting') }}</label></div>
                    <div v-if="$store.state.auth.role === 'admin'" class="mb-4"><input class="mr-2" id="reason_6" type="radio" v-model="reason" value="6"> <label for="reason_6">{{ $t('spam') }}</label></div>
                    <div class="mb-4"><input class="mr-2" id="reason_9" type="radio" v-model="reason" value="9"> <label for="reason_9">{{ $t('duplicate') }}</label></div>
                </div>
			</vx-input-group>
		</div>
	</vs-prompt>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "MoveTrashOrder",
	mixins: [databaseManager, notifier],
	props: {
		active: { required: true, type: Boolean },
		order: { required: true },
		mode: { type: String, default: "order" }
	},
	data() {
		return {
			date: new Date(),
            reason: "0",
			about: "",
		}
	},
	watch: {
		popupActive(value) {
			if(value) return;
			this.date = new Date();
			this.about = "";
		}
	},
	computed: {
		minDate() {
			return new Date();
		},
		popupActive: {
			get() {
				return this.active;
			},
			set(newValue) {
				this.$emit("update:active", newValue);
			}
		},
	},
	methods: {
		async moveTrash() {
			this.popupActive = true;

			if(await this.$validator.validateAll() !== true) return;

			try {
				let newTask = null;

				if(this.mode === "order") {
				 	newTask = await this.dbMoveTrashOrder(this.order.id, this.reason);
				}

				this.about = "";
				this.date = new Date();
				this.popupActive = false;

				if(!!this.order) {
					this.order.task = newTask;
				}

				this.notifySuccess(this.$t('addedSuccessfully'));

                // this.$forceUpdate();
				this.$emit("updateModel");
			} catch (e) {
				this.notifyError(e.message)
			}
		},
	}
};
</script>

<style lang="scss">
.add-order-task {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}
</style>
